module.exports = __webpack_public_path__ + "static/media/doc01.7428a4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc01.png
// module id = 53
// module chunks = 0